export const getScoreColor = (overallScore: number) => {
    if (overallScore < 50) {
        return 'red';
    } else if (overallScore < 90) {
        return 'yellow';
    } else {
        return 'green';
    }
};